import type { CoreBookingDocument, ParameterID } from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'
/**
 * Send email for booking by internal ID.
 *
 * @endpoint POST /api/saas/me/bookings/{internal_id}/send_email
 * @scope saas
 * @see https://flecto.dev/api-12055148
 */
export async function sendBookingEmail(
  internal_id: ParameterID,
  payload: {
    cc?: string
    subject?: string
    body?: string
    attachment_document_ids?: number[]
  }
): Promise<void> {
  const response = await api.post(
    `/api/saas/me/bookings/${internal_id}/send_email`,
    payload
  )

  const { data } = deserialize<CoreBookingDocument>(response.data)

  return data
}
